<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{ offset: number; limit: number; total: number }>();
const emit = defineEmits<{ "update:offset": [number] }>();

const from = computed(() => (props.total === 0 ? 0 : props.offset + 1));
const to = computed(() => Math.min(props.offset + props.limit, props.total));
const canPrev = computed(() => props.offset > 0);
const canNext = computed(() => props.offset + props.limit < props.total);

function prev() { if (canPrev.value) emit("update:offset", Math.max(0, props.offset - props.limit)); }
function next() { if (canNext.value) emit("update:offset", props.offset + props.limit); }
</script>

<template>
  <div v-if="total > limit" class="pager">
    <button :disabled="!canPrev" @click="prev">← Vorige</button>
    <span class="range">{{ from }}–{{ to }} van {{ total }}</span>
    <button :disabled="!canNext" @click="next">Volgende →</button>
  </div>
</template>

<style scoped>
.pager { display: flex; align-items: center; justify-content: center; gap: 16px; margin-top: 18px; }
.pager button { border: 1px solid var(--border-input); background: var(--surface); border-radius: 999px; padding: 7px 14px; font-size: 13px; font-weight: 600; cursor: pointer; }
.pager button:disabled { opacity: 0.45; cursor: not-allowed; }
.range { color: var(--muted); font-size: 13px; }
</style>
